export default __webpack_public_path__ + "static/media/ios-808-surf-tracker.085afa08.png";